import { fetchWrapper } from "../Helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}/ds-campaigns`;
const base_url = `${process.env.REACT_APP_API_URL}`;

export const jobCampaignsService = {
  getAllCampaigns,
  generateCampaignWithAI,
  getCampaignById,
  crateCampaign,
  saveBrief,
  updateCampaign,
  uploadMedia,
  deleteCampaign,
  updateCampaignStatus,
  fetchAmount,
  getSocialMedia,
  getCategories,
  getCountry,
  getBrandProfiles,
  getInfluencerList,
  getOffersByCampaignId,
};

function getAllCampaigns(options) {
  let filterString = "";
  if (options && options.filter) {
    filterString = options.filter;
  }
  if (options && options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  if (options && options.cmp_type) {
    filterString += filterString.length > 0 ? `&` : "";
    filterString += `cmp_type=${options.cmp_type}`;
  }
  const url =
    filterString.length > 0 ? `${baseUrl}?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}

function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : "";
  filterString += `page=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : "";
    filterString += `per_page=${options.pageSize}`;
  }
  return filterString;
}

function getCampaignById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function generateCampaignWithAI(description) {
  return fetchWrapper.post(`${baseUrl}/generate`, { description });
}

function crateCampaign() {
  return fetchWrapper.post(`${baseUrl}/ds-campaigns`);
}

function saveBrief(params) {
  return fetchWrapper.post(`${baseUrl}`, params);
}

function updateCampaign(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function updateCampaignStatus(id, params) {
  return fetchWrapper.patch(`${baseUrl}/${id}/status`, params);
}
function uploadMedia(file) {
  let formData = new FormData();
  formData.append("file_name", file);
  formData.append("is_thumbnail", "1");

  return fetchWrapper.postFile(
    `${process.env.REACT_APP_API_URL}/upload/asset`,
    formData
  );
  // return fetchWrapper.postFile(`${process.env.REACT_APP_API_URL}/file/uploads`, formData);
}

function deleteCampaign(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function fetchAmount() {
  return fetchWrapper.get(`${base_url}/cmp-quota/available?amount=1`);
}

function getSocialMedia() {
  return fetchWrapper.get(`${base_url}/ref/social-media`);
}

function getCategories() {
  return fetchWrapper.get(`${base_url}/tama-categories/dropdown`);
}

function getCountry() {
  return fetchWrapper.get(`${base_url}/ref/countries`);
}

function getBrandProfiles() {
  return fetchWrapper.get(`${base_url}/me/brand-profile`);
}

function getInfluencerList(campaignId) {
  return fetchWrapper.get(`${baseUrl}/${campaignId}/invites`);
}

function getOffersByCampaignId(campaign_id) {
  return fetchWrapper.get(
    `${base_url}/campaigns/${campaign_id}/offers?per_page=1`
  );
}
